const maskEmail = (email?: string) => {
  if (!email) return '';

  const [start, end] = email.split('@');
  return start.slice(0, start.length / 2) + '******@' + end;
};

export default maskEmail;
